import styles from '../../styles/statisticCard.module.scss';

const StatisticCard = ({ data }) => {
  const { title, value, change, period, type } = data;
  return (
    <div className={styles.card}>
      <div className={styles.card__title}>{data.title}</div>
      <div className={`${styles.card__value} lato `}>{data.value}</div>
      <div className={styles.card__footer}>
        <div className={styles.card__footer__left}>
          <div className={styles.card__footer__left__percentages}>
            <img src={`/assets/icons/${type}.svg`} />
            <span
              className={`${styles.card__footer__left__percentages__change} ${
                type === 'up'
                  ? styles['card__footer__left__percentages__change--positive']
                  : styles['card__footer__left__percentages__change--negative']
              }`}
            >
              {change}%
            </span>
          </div>
          <p>{period}</p>
        </div>
        <div className={styles.card__footer__right}>
          <img
            src={`/assets/icons/${type === 'up' ? 'green-chart' : 'red-chart'}.svg`}
          />
        </div>
      </div>
    </div>
  );
};
export default StatisticCard;
